import React,{useState,useEffect} from 'react'
import './ScrollAr.css'

const ScrollUp = () => {

    const [backToTop,setBackToTop] = useState(false);

    useEffect(()=>{
        window.addEventListener("scroll",()=>{
            if(window.scrollY >= 350){
                setBackToTop(true)
            }else{
                setBackToTop(false)
            }
        })
    },[])

    const scrollUp = ()=>{
        window.scrollTo({
            top:0,
            behavior:"smooth",
        })
    }

    return (
        <>
            {
                <div>
                    <div
                    onClick={scrollUp}
                    className={window.scrollY >= 350 ? "scrollup-ar show-scroll" :"scrollup-ar"}>
                        <i className="ri-arrow-up-line"></i>
                    </div>
                </div>
            }
        </>
    )
}

export default ScrollUp